import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { SingleSelectDropdownComponent } from '../../../business-details/single-select-dropdown.component';
import { OffcanvasSheetComponent } from '../../../shared/offcanvas-sheet/offcanvas-sheet.component';

export interface FactoryOrderFormPayload {
  productionOrderID?: number;
  finishedGoodItemID: number | null;
  quantityToProduce: number | null;
  plannedStartDate: string;
  plannedEndDate: string;
  notes: string;
}

@Component({
  selector: 'app-factory-order-offcanvas',
  standalone: true,
  imports: [CommonModule, FormsModule, HttpClientModule, SingleSelectDropdownComponent, OffcanvasSheetComponent],
  templateUrl: './factory-order-offcanvas.component.html',
  styleUrls: [
    '../../../shared/offcanvas-sheet/offcanvas-sheet.shared.css',
    './factory-order-offcanvas.component.css',
  ],
})
export class FactoryOrderOffcanvasComponent implements OnChanges {
  constructor(private http: HttpClient) {}
  @Input() visible = false;
  @Input() order: any = null;
  @Input() isEditing = false;
  @Input() products: any[] = [];

  @Output() closeCanvas = new EventEmitter<void>();
  @Output() save = new EventEmitter<FactoryOrderFormPayload>();

  readonly Math = Math;

  formData = {
    finishedGoodItemID: null as number | null,
    quantityToProduce: 1 as number | null,
    plannedStartDate: new Date().toISOString().split('T')[0],
    plannedEndDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    notes: '',
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visible && (changes['visible'] || changes['order'])) {
      if (this.order) {
        this.formData = {
          finishedGoodItemID: this.order.finishedGoodItemID ?? null,
          quantityToProduce: this.order.quantityToProduce ?? null,
          plannedStartDate: this.order.plannedStartDate?.split('T')[0] ?? new Date().toISOString().split('T')[0],
          plannedEndDate: this.order.plannedEndDate?.split('T')[0] ?? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
          notes: this.order.notes ?? '',
        };
      } else {
        this.resetForm();
      }
    }
  }

  get title(): string {
    return this.isEditing ? 'Edit Order' : 'Add Order';
  }

  get productsOptions(): { value: string; label: string }[] {
    return this.products.map(p => ({ value: String(p.itemID), label: p.itemName }));
  }

  get selectedProductName(): string {
    if (!this.formData.finishedGoodItemID) return '';
    return this.products.find(p => p.itemID === this.formData.finishedGoodItemID)?.itemName ?? '';
  }

  onProductSelectChange(val: string | null): void {
    this.formData.finishedGoodItemID = val != null ? +val : null;
  }

  onQuantityChange(): void {
    // Quantity change handler
  }

  onSave(): void {
    const payload: FactoryOrderFormPayload = { ...this.formData };
    if (this.isEditing && this.order?.productionOrderID) {
      payload.productionOrderID = this.order.productionOrderID;
    }
    this.save.emit(payload);
    this.onClose();
  }

  onClose(): void {
    this.closeCanvas.emit();
  }

  private resetForm(): void {
    this.formData = {
      finishedGoodItemID: null,
      quantityToProduce: 1,
      plannedStartDate: new Date().toISOString().split('T')[0],
      plannedEndDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      notes: '',
    };
  }
}
